type PromiseWithResolvers<T> = {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
};

/**
 * A ponyfill for Promise.withResolvers
 *
 * The functionality is a little too new (baseline 2024) so I don't want to
 * assume our customers will have it yet. We should be able to remove this (or
 * not!) once we settle down our browser requirements (or add CoreJS).
 */
export function promiseWithResolvers<T>(): PromiseWithResolvers<T> {
  if (Promise.withResolvers) {
    return Promise.withResolvers();
  }

  let resolve, reject;
  const promise: Promise<T> = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return {
    promise,
    resolve,
    reject,
  };
}
